var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";

import Header from "../../../components/Library/Header";

import styles from "./SubscriptionHeader.css";

var SubscriptionHeader = function (_Component) {
  _inherits(SubscriptionHeader, _Component);

  function SubscriptionHeader() {
    _classCallCheck(this, SubscriptionHeader);

    return _possibleConstructorReturn(this, (SubscriptionHeader.__proto__ || Object.getPrototypeOf(SubscriptionHeader)).apply(this, arguments));
  }

  _createClass(SubscriptionHeader, [{
    key: "render",
    value: function render() {
      return React.createElement(Header, {
        className: styles.newsletter,
        subText: this.props.subText,
        text: this.props.text,
        subscription: this.props.subscription });
    }
  }]);

  return SubscriptionHeader;
}(Component);

SubscriptionHeader.propTypes = {
  subText: PropTypes.string,
  text: PropTypes.string
};

SubscriptionHeader.defaultProps = {
  text: "Newsletters"
};

export default SubscriptionHeader;


// WEBPACK FOOTER //
// ./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.js